import { useBaseAPI } from 'apiServices/baseAPI';

export function useConsentAPI({ patientID }) {
  return useBaseAPI({
    method: 'GET',
    route: `consentimento/recurso/${patientID}/politica`,
    additionalHeaders: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  });
}
